const socialMediaConfig = {
  instagram: {
    link: "https://www.instagram.com/whole_sol/"
  },
  facebook: {
    link: "https://www.facebook.com/WholeSolBlendBar/",
    restaurantMetadata: {
      address: "",
      locality: "",
      region: "",
      postalCode: "",
      country: "",
      email: "",
      phoneNumber: ""
    },
    appID: "",
    type: "restaurant.restaurant",
    image: ""
  },
  twitter: {
    link: "",
    companyTwitterHandle: "",
    image: ""
  }
};

export default socialMediaConfig;



// WEBPACK FOOTER //
// ./config/socialMediaConfig.js